var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79914 10.6534C9.50876 7.55913 8.93116 6.09039 8.2298 5.33127C7.3304 4.35761 6.23297 4.50613 4.55794 3.00439C3.95476 2.4847 3.37913 1.93386 2.83341 1.35411C2.77922 1.28251 2.7014 1.23244 2.61377 1.2128C2.52615 1.19316 2.4344 1.20523 2.35483 1.24685C1.36467 1.93171 0.38276 5.19099 1.48844 7.89744C2.72614 10.9999 6.43925 12.6915 7.04985 12.1056C7.54493 11.6518 6.62903 9.1764 5.70488 7.97995C5.05713 7.17229 4.25487 6.50187 3.345 6.00788",
    stroke: "#838991",
    strokeWidth: 0.881357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8659 7.82306C13.0403 7.84629 12.2273 8.03132 11.473 8.36765C10.3921 8.85448 8.82432 10.2572 8.9976 10.7605C9.22864 11.4206 12.4632 11.5857 14.4847 9.86114C16.2835 8.35114 16.8034 5.6777 16.3413 4.83607C16.3078 4.77291 16.2526 4.72395 16.1859 4.69818C16.1193 4.67242 16.0455 4.67157 15.9782 4.69579C15.3719 4.91371 14.7551 5.10098 14.1299 5.25689C12.3807 5.70246 11.6545 5.17437 10.6726 5.52918C9.93979 5.83047 9.34955 6.40005 9.02235 7.12169",
    stroke: "#838991",
    strokeWidth: 0.881357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaf);
export default __webpack_public_path__ + "static/media/icon_leaf.0a198b1bee3cda8d190037b771156598.svg";
export { ForwardRef as ReactComponent };